import React, { useEffect, useContext, useState } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core
import { makeStyles } from "@mui/styles";

// core components
import { Stack, Grid, Box } from "@mui/material";
import { ArrowRightAlt } from "@mui/icons-material";

import banner2 from "assets/img/banner2.webp";

import {
  dashboardStyle,
  ButtonExit,
  // ColorLinearProgress,
} from "components/dashboardStyle.js";

const useStyles = makeStyles(dashboardStyle);

export default function DashboardCustomers() {
  const classes = useStyles();

  const [buttonLinksPayments, setButtonLinksPayments] = useState(false);

  const { UserAuth } = useContext(UrlServicesContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (buttonLinksPayments) {
    return <Navigate to="/account/payments" />;
  }

  return (
    <>
      <Box className={classes.cardDashboardTop} sx={{ mt: { xs: 8, sm: 1 } }}>
        <Grid container>
          <Grid item xs={12} md={8}>
            <Stack direction="row" spacing={2}>
              <div style={{ fontSize: 16, color: "#fff" }}>
                Bienvenido{" "}
                <b style={{ fontSize: 22 }}>A tu dashboard administrativo</b>
              </div>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <div style={{ fontSize: 16, color: "#fff", float: "right" }}>
              Cliente: <b>{UserAuth.clientsName}</b>s
            </div>
          </Grid>
        </Grid>
      </Box>
      <Grid container>
        <Grid item xs={12} md={6}>
          <div className={classes.cardDashboardText} style={{ marginTop: 40 }}>
            <div style={{ fontSize: 24, color: "#000", padding: "25px 40px" }}>
              <span style={{ fontWeight: 550 }}>
                Genera enlaces de pago de forma rápida y sencilla
              </span>
              <br></br>
              <span style={{ fontSize: 16 }}>
                Con nuestra plataforma, podrás crear y enviar enlaces de pago
                personalizados a tus clientes en cuestión de segundos.
                Simplifica tus cobros y ofrece una experiencia de pago
                profesional sin complicaciones. ¡Gracias por confiar en nosotros
                para gestionar tus transacciones!"
              </span>
              <br></br>
              <center>
                <ButtonExit
                  endIcon={<ArrowRightAlt />}
                  onClick={() => setButtonLinksPayments(true)}
                >
                  IR AL MÓDULO
                </ButtonExit>
              </center>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <center>
            <img
              src={banner2}
              alt={`firsttimetamplate1`}
              style={{
                marginTop: 40,
                width: "75%",
                objectFit: "container",
              }}
            />
          </center>
        </Grid>
      </Grid>
    </>
  );
}
